import Vue from 'vue'
import Router from 'vue-router'
import { ForgotPassword, Login, Logout, PasswordConfirmation, PasswordChallenge } from '@/components/auth'

// Containers
import FileStore from '@/containers/FileStore'
import Public from '@/containers/Public'

// Views
import GetFiles from '@/views/GetFiles'
import ChangePassword from '@/views/ChangePassword'
import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

let appRoutes = [
  {
    path: '/auth',
    redirect: '/auth/login',
    name: 'Auth',
    component: Public,
    children: [
      {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        props: true
      },
      {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        props: true
      },
      {
        path: '/auth/forgot',
        name: 'ForgotPassword',
        component: ForgotPassword,
        props: true
      },
      {
        path: '/auth/confirm-password',
        name: 'PasswordConfirmation',
        component: PasswordConfirmation,
        props: true
      },
      {
        path: '/auth/password-challenge',
        name: 'PasswordChallenge',
        component: PasswordChallenge,
        props: true
      }
    ]
  },
  {
    path: '/',
    redirect: '/getfiles',
    name: 'Home',
    component: FileStore,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'getfiles',
        name: 'GetFiles',
        component: GetFiles,
        meta: { requiresAuth: true }
      },
      {
        path: 'user/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '*',
    name: 'Error',
    component: Public,
    meta: { requiresAuth: false },
    children: [
      {
        path: '*',
        name: 'PageNotFound',
        component: PageNotFound,
        meta: { requiresAuth: false }
      }
    ]
  }
]

const router = new Router({
  linkActiveClass: 'open active',
  routes: appRoutes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js